// Tipos e utilitários de OS/agenda. Horários exibidos no fuso do navegador (a MAZA opera em America/Sao_Paulo).

export interface OsAgenda {
  id: string; numero: string; status: string; prioridade: string; descricao: string;
  agendada_para: string | null; janela_min: number | null; versao: number;
  tipo: string; natureza: string; cliente_id: string; cliente: string; local_id: string; local: string; endereco: string;
  lat: number | null; lng: number | null; responsavel_id: string | null; responsavel: string | null; criado_em?: string;
  data_sugerida?: string | null; competencia?: string | null;
}
export interface Tecnico { id: string; nome: string; telefone: string | null; placa: string | null }
export interface ConfigAgenda { inicio: string; fim: string; duracao_padrao_min: number; fuso: string }
export interface Conflito { id: string; numero: string; agendada_para: string; janela_min: number | null; local: string }

export const NOME_STATUS_OS: Record<string, string> = {
  aberta: 'A agendar', agendada: 'Agendada', em_deslocamento: 'A caminho', em_execucao: 'Em execução',
  pausada: 'Pausada', concluida: 'Concluída', cancelada: 'Cancelada',
};
export const NOME_PRIORIDADE: Record<string, string> = { critica: 'Crítica', alta: 'Alta', media: 'Média', baixa: 'Baixa' };


const DIAS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

export const hora = (iso: string) => new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
export const diaCurto = (d: Date) => `${DIAS[d.getDay()]} ${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
export const diaLongo = (d: Date) => d.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' });

export function inicioDoDia(d: Date) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
export function somaDias(d: Date, n: number) { const x = new Date(d); x.setDate(x.getDate() + n); return x; }
/** Segunda-feira da semana de d */
export function inicioDaSemana(d: Date) { const x = inicioDoDia(d); const dow = (x.getDay() + 6) % 7; return somaDias(x, -dow); }
export const mesmoDia = (a: Date, b: Date) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
/** "2026-10-02" no fuso local */
export const isoDia = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
/** "HH:MM" → minutos desde 00:00 */
export const minutosDe = (hhmm: string) => { const [h, m] = hhmm.split(':').map(Number); return (h ?? 0) * 60 + (m ?? 0); };
/** data "AAAA-MM-DD" + hora "HH:MM" locais → ISO com fuso */
export const juntarDataHora = (data: string, hhmm: string) => new Date(`${data}T${hhmm}:00`).toISOString();
export const hhmm = (d: Date) => `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;

export function duracaoTexto(min: number | null) {
  if (!min) return '';
  const h = Math.floor(min / 60), m = min % 60;
  return h ? `${h}h${m ? String(m).padStart(2, '0') : ''}` : `${m} min`;
}

export function textoConflitos(c: Conflito[]) {
  if (!c.length) return null;
  return `Atenção: sobrepõe ${c.map((x) => `${x.numero} (${hora(x.agendada_para)}, ${x.local})`).join(', ')} do mesmo técnico. Gravado mesmo assim.`;
}

export const NOME_RESULTADO: Record<string, string> = { resolvido: 'Resolvido', pendente: 'Ficou pendente', orcamento: 'Precisa de orçamento', sem_defeito: 'Sem defeito encontrado' };
export const NOME_EVENTO_OS: Record<string, string> = {
  deslocamento_inicio: 'Saiu para o local', check_in: 'Chegou ao local', etiqueta_lida: 'Leu a etiqueta', pausa: 'Pausou', retomada: 'Retomou',
  check_out: 'Concluiu no local', mudanca_status: 'Status alterado', nota: 'Nota',
};
export const NOME_ACAO_ATIVO: Record<string, string> = {
  inspecionado: 'Inspecionado', ajustado: 'Ajustado', reparado: 'Reparado', trocado: 'Trocado', instalado: 'Instalado', removido: 'Removido', configurado: 'Configurado',
};
/** "a 2,2 km do local" / "a 85 m do local" */
export function distanciaTexto(m: number | string | null) {
  if (m == null) return null;
  const v = Number(m);
  return v >= 1000 ? `a ${(v / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} km do local` : `a ${Math.round(v)} m do local`;
}
